import {
    API_SUCCESS,
    API_FAIL,
    GET_CHARTS_DATA,
    GET_DONUT_CHART,
    GET_DONUT_CHART_SUCCESS,
    GET_DONUT_CHART_FAIL,
    GET_TOTAL_E_DOCUMENT_SUCCESS,
    GET_TOTAL_E_DOCUMENT_FAIL,
    GET_TOTAL_E_DOCUMENT,
    GET_TOTAL_NOTIFICATION,
    GET_TOTAL_NOTIFICATION_SUCCESS,
    GET_TOTAL_NOTIFICATION_FAIL, GET_STACKED_DATA, GET_STACKED_DATA_SUCCESS, GET_STACKED_DATA_FAIL
} from "./actionTypes";

export const apiSuccess = (actionType, data) => ({
    type: API_SUCCESS,
    payload: { actionType, data },
});

export const apiFail = (actionType, error) => ({
    type: API_FAIL,
    payload: { actionType, error },
});

// charts data
export const getChartsData = (periodType) => ({
    type: GET_CHARTS_DATA,
    payload: periodType
});

export const getTotalEDocument = () => ({
    type: GET_TOTAL_E_DOCUMENT,
});

// Action get list data from api
export const getTotalEDocumentSuccess = (totalCount) => ({
    type: GET_TOTAL_E_DOCUMENT_SUCCESS,
    payload: totalCount,
});

export const getTotalEDocumentFail = error => ({
    type: GET_TOTAL_E_DOCUMENT_FAIL,
    error,
});
export const getDonutChart = () => ({
   type: GET_DONUT_CHART
});
export const getDonutChartSuccess = data => ({
    type: GET_DONUT_CHART_SUCCESS,
    payload: data
});
export const getDonutChartFail = error => ({
    type: GET_DONUT_CHART_FAIL,
    payload: error
});
export const getTotalNotification = () => ({
    type: GET_TOTAL_NOTIFICATION,
});

// Action get list data from api
export const getTotalNotificationSuccess = (totalCount) => ({
    type: GET_TOTAL_NOTIFICATION_SUCCESS,
    payload: totalCount,
});

export const getTotalNotificationFail = error => ({
    type: GET_TOTAL_NOTIFICATION_FAIL,
    error,
});

export const getStackedData = () => ({
    type: GET_STACKED_DATA
});
export const getStackedDataSuccess = data => ({
    type: GET_STACKED_DATA_SUCCESS,
    payload: data
});
export const getStackedDataFail = error => ({
    type: GET_STACKED_DATA_FAIL,
    payload: error
});
